<div class="table-wrapper">
  <table class="table table-striped">
    <thead class="thead-dark">
      <tr>
        <ng-container *ngFor="let colName of columnNames">
          <!-- Normal column -->
          <th scope="col" *ngIf="colName.searchType !== 'check'" class="text-center" [ngClass]="enableSorting ? 'clickeable' : ''" (click)="sort(colName)">
            {{ 'table.headers.' + colName.name | translate }}
          <span *ngIf="colName.sort === 'asc'" class="material-icons align-middle">arrow_drop_up</span>
          <span *ngIf="colName.sort === 'desc'" class="material-icons align-middle">arrow_drop_down</span>
          </th>
          <!-- Select column -->
          <th scope="col" *ngIf="colName.searchType === 'check'" class="text-center" class="text-center">
            <div class="check-container all">
              <input type="checkbox" [checked]="selectAll ? 'checked' : ''">
              <span class="checkmark all" (click)="checkAll()"></span>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rowValue of renderedData | paginate: { itemsPerPage:  getPageLength(), currentPage: p }">
        <ng-container *ngFor="let colName of columnNames">
          <ng-container *ngIf="colName.searchType === 'check' && !hideSelection">
            <td class="text-center">
              <div class="check-container">
                <input type="checkbox" [checked]="rowValue.checked ? 'checked' : ''">
                <span class="checkmark" (click)="selectDocument(rowValue)"></span>
              </div>
            </td>
          </ng-container>
          <td class="text-center" *ngIf="colName.searchType === 'text'">{{ parseRowValue(rowValue, colName) }}
            <span class="link" *ngIf="shouldHideFullText(colName, rowValue)" (click)="showText(rowValue, colName)">...</span>
            <span class="link" *ngIf="fullTextConfig[rowValue.id][colName.name]" (click)="showText(rowValue, colName)">[...]</span>
          </td>
          <td class="text-center" *ngIf="colName.searchType === 'date'">{{rowValue[colName.name] | dateFormat : 'DD-MMM-YYYY'}}
          </td>
          <td class="text-center" *ngIf="colName.searchType === 'boolean' ">{{'table.documentsValues.'+rowValue['Status'] | translate}}
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
<div class="mt-4 mb-3 d-flex" *ngIf="renderedData && renderedData.length > getPageLength()">
  <pagination-controls  class="ms-auto"
    previousLabel="{{'components.pagination.previous' | translate}}"
    nextLabel="{{'components.pagination.next' | translate}}"
    (pageChange)="p = $event"></pagination-controls>
</div>
